import { Table } from '@/components/category/table'

export const Categories = () => {
  return (
    <>
      <Table pageSize={20} onIndex />
    </>
  )
}
